import React from 'react';

import FAQs from '../../components/FAQs';
import Link from '../../components/Link';
import {CoachingFAQs} from '../../constants/coaching';
import {getBrandName} from '../../components/Brand';

const MembershipFAQs = [{
  question: 'What is included in the membership?',
  answer: `The ${getBrandName()} membership includes exclusive access to all of the course content, unlimited peer mock interviews, our members-only Discord community, and so much more! Our courses include detailed lessons, guides, videos, and frameworks to help you ace your interview. All of our courses include free lessons - browse our courses at aced.io/courses.`,
}, {
  question: `What's included in the ${getBrandName()} Discord community?`,
  answer: `The ${getBrandName()} Discord is a private community of thousands of other ${getBrandName()} members. It has relevant, fresh information on acing interviews and recent interview experiences shared by candidates like yourself. Join by clicking "Community" in the sidebar once you're a member.`,
}, {
  question: 'How can I create an alias instead of using my real name?',
  answer: (
    <span>
      You can visit the
      {' '}
      <Link className="text-indigo" href="/account">account Page</Link>
      , click &quot;Edit Profile&quot;, and there you will find a checkbox
      to go anonymous and select a username.
    </span>),
}, {
  question: `How can I unlink my Google/Facebook account from my ${getBrandName()} account?`,
  answer: (
    <span>
      You can change your email by visiting the
      {' '}
      <Link className="text-indigo" href="/account">account Page</Link>
      . If you originally signed up with Google or Facebook,
      you&apos;ll need to set a new password before you can change your email.
    </span>),
}, {
  question: 'Can support assist me with career questions or offer job advice?',
  answer: (
    <span>
      {`At this time, ${getBrandName()} support offers assistance with account and service-related issues.
      If you would like more in-depth advice, we recommend you take a look at`}
      {' '}
      <Link className="text-indigo" href="/coaching">coaching</Link>
      .
    </span>),
}, {
  question: "I've reached out to support. When can I expect a response?",
  answer: 'Our business hours are Monday through Thursday, 8 AM - 8 PM PT. You can expect a response within 2 business days.',
}, {
  question: `How can I delete my ${getBrandName()} account?`,
  answer: (
    <span>
      Users can delete their accounts on the
      {' '}
      <Link className="text-indigo" href="/account">account Page</Link>
      . You will be prompted to cancel your auto-renew subscriptions first.
      For security reasons, you will need to set a password and enter it on deletion.
      You will lose all access to subscriptions and coaching credits upon deletion.
    </span>),
}, {
  question: 'How does the refund policy work?',
  answer: (
    <span>
      If you aren&rsquo;t satisfied with your membership for any reason, reach out to us
      and let us know how we can help. We offer full refunds within 5 days of purchase.
    </span>),
}, {
  question: 'What is your renewal policy?',
  answer: (
    <span>
      {`Your ${getBrandName()} membership will renew automatically. You can cancel your plan at
      any time before your renewal date by visiting the`}
      {' '}
      <Link className="text-indigo" href="/account">account page</Link>
      .
    </span>),
}, {
  question: 'I have a question not answered here.',
  answer: (
    <span>
      Shoot us an email at
      {' '}
      <Link className="text-indigo" href="mailto:support@aced.io">support@aced.io</Link>
      .
    </span>),
}];

const SupportFAQs = () => (
  <>
    <h3 className="text-lg font-medium text-gray-700">Membership</h3>
    <FAQs items={MembershipFAQs} />
    <h3 className="text-lg font-medium text-gray-700">Coaching</h3>
    <FAQs items={CoachingFAQs} />
  </>
);

export default SupportFAQs;
